// extracted by mini-css-extract-plugin
export var wrapper = "styles-module--wrapper--uqur-";